// extracted by mini-css-extract-plugin
export default {"root":"SectionTitle_root__QcSUk","title":"SectionTitle_title__gZ1-f","description":"SectionTitle_description__J8NF0"};